/* eslint-disable max-len */
// -sort-keys object-literal-key-quotes
export const translations = {
  COMMON: {
    DATE_FORMAT: 'TT.MM.JJJJ',
    UNIT: {
      GROESSE: 'cm',
      ALTER: 'Jahre',
      PROZENT: '%'
    }
  },
  ERRORS: {
    VMR: {
      WRONG_NUMBER: 'Bitte nur Zahlen eingeben',
      LENGTH_NOT_6_OR_8: 'Die Vermittlernummer hat 6 oder 8 Stellen'
    },
    DATUM: {
      WRONG_DATE: 'Das Datum ist nicht korrekt',
      PARTIAL: 'Das Datum ist nicht korrekt',
      DATE_SMALLER_THAN_MIN_DATE: 'Das Datum liegt zu weit in der Vergangenheit',
      DATE_BIGGER_THAN_MAX_DATE: 'Das Datum liegt zu weit in der Zukunft'
    },
    INTEGER: {
      WRONG_NUMBER: 'Bitte nur ganze Zahlen eingeben',
      WRONG_DOUBLE_NUMBER: 'Bitte nur Fließkommazahlen eingeben',
      MISSING_DECIMAL_NUMBERS: 'Bitte geben Sie Nachkommastellen ein',
      TOO_SMALL: 'Bitte geben Sie mindestens {limit} ein',
      TOO_BIG: 'Bitte geben Sie höchstens {limit} ein',
      TOO_MANY_DIGITS: 'Bitte geben Sie höchstens {limit} Nachkommastellen ein'
    },
    IBAN: {
      COUNTRYCODE: 'Die 2-stellige Länderkennung wurde nicht erkannt',
      CHECKSUM: 'Die Prüfsumme ist invalide',
      SHORT: 'Eingabe zu kurz',
      WRONG: 'Die IBAN ist fehlerhaft',
      LENGTH: 'Die Länge ist falsch: {limit} wird benötigt'
    },
    EMAILADRESSE: {
      WRONG_EMAIL: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    },
    MOBILNUMMER: {
      WRONG_PHONE_LETTER: 'Die Mobilnummer enthält unerlaubte Zeichen',
      WRONG_PHONE_TO_SHORT: 'Die Mobilnummer ist zu kurz',
      WRONG_PHONE_TO_LONG: 'Die Mobilnummer ist zu lang'
    },
    INPUT: {
      MAXIMUM_CHARACTERS: 'Bitte geben Sie höchstens {x} Zeichen ein',
      MINIMUM_CHARACTERS: 'Bitte geben Sie mindestens {x} Zeichen ein'
    }
  },
  BROWSER_WARNING: {
    HEADLINE: 'Leider ist Ihr Browser veraltet.',
    DESCRIPTION: '<p>Sehr geehrte Interessentin,<br/>sehr geehrter Interessent,</p><p>leider nutzten Sie einen Browser, der nicht ' +
        'mehr unterstützt wird!</p><p>Auf unseren Seiten der LV 1871 möchten wir Ihnen zuverlässige und sichere Services anbieten.' +
        '</p><p>Ältere Browser haben teilweise Sicherheitslücken und verhindern eine reibungslose und zuverlässige Nutzung unserer ' +
        'Website.</p><p>Um alle Inhalte unserer Website nutzen zu können, bitten wir Sie, einen der folgenden Browser zu nutzen bzw. ' +
        'herunterzuladen:</p><ul class="lv-browser-warning-list">' +
        '<li><a class="lv-browser-warning-link" href="https://www.google.com/chrome" target="_blank">Chrome</a></li>' +
        '<li><a href="https://www.mozilla.org/firefox" target="_blank" class="lv-browser-warning-link">Firefox</a></li>' +
        '<li><a href="https://www.microsoft.com/edge" target="_blank" class="lv-browser-warning-link">' +
        'Microsoft Edge (Nachfolger Internet Explorer)</a></li>' +
        '<li class="lv-hide-list-element {isMac}">' +
        '<a href="https://www.apple.com/safari/" target="_blank" class="lv-browser-warning-link">Safari</a></li></ul>' +
        '<p>Vielen Dank!</p><p>Ihre LV 1871</p>'
  }
};
